import cookies from './cookies'
import algoliaSearchKey from '../tools/algoliaSearchKey'

const searchInsights = () => ({
    ...cookies(),
    enabled: false,
    init() {
        this.enable()
    },
    enable() {
        // Don't allow us to enable multiple times
        if (this.enabled || !this.getCookieOption('analytics')) {
            return
        }

        window.aa('init', {
            appId: process.env.MIX_ALGOLIA_APP_ID,
            apiKey: algoliaSearchKey(),
        })

        const customerId = window.Alpine.store('user').id_customer
        const authenticatedToken = customerId ? `user-${customerId}` : ''
        const anonymousToken = window.Alpine.store('search').userToken
        const activeToken = authenticatedToken || anonymousToken

        if (activeToken) {
            window.aa('setUserToken', activeToken)
        } else {
            window.aa('getUserToken', {}, (err, userToken) => {
                if (err) {
                    return
                }

                window.Alpine.store('search').userToken = userToken
            })
        }
        this.enabled = true
    },
    productClick(event) {
        if (!this.enabled) {
            return
        }

        const { productObjectId, productQueryId } = window.Alpine.store('search')

        event.detail.ecommerce.click.products.forEach((product) => {
            let method = 'clickedObjectIDs'

            const eventData = {
                eventName: 'Product Clicked',
                index: 'new_products',
                objectIDs: product.id ? [product.id.toString()] : [],
                context: event.detail.ecommerce.click.actionField.list,
            }

            if (productObjectId == product.id && productQueryId) {
                method = 'clickedObjectIDsAfterSearch'
                eventData.queryID = productQueryId
                eventData.positions = [product.position]
            }

            window.aa(method, eventData)
        })
    },
    productUpdateEvent(event, product) {
        if (!this.enabled) {
            return
        }

        if (event.detail.cartAction === 'add') {
            const { productObjectId, productQueryId } = window.Alpine.store('search')

            let method = 'convertedObjectIDs'
            const eventData = {
                eventName: 'Product Added',
                index: 'new_products',
                objectIDs: product.productId ? [product.productId.toString()] : [],
                context: event.detail.fromPage,
            }

            if (productObjectId == product.productId && productQueryId) {
                method = 'convertedObjectIDsAfterSearch'
                eventData.queryID = productQueryId
            }

            window.aa(method, eventData)
        }
    },
    cmsPageClick(event) {
        if (!this.enabled) {
            return
        }

        let method = 'clickedObjectIDs'
        const eventData = {
            eventName: 'CMS Page Clicked',
            index: 'new_cms_pages',
            objectIDs: event.detail.id ? [event.detail.id.toString()] : [],
            context: event.detail.context,
        }

        if (event.detail.queryId && event.detail.position) {
            method = 'clickedObjectIDsAfterSearch'
            eventData.queryID = event.detail.queryId
            eventData.positions = [event.detail.position]
        }

        event.preventDefault()

        window.aa(method, eventData)
    },
    categoryClick(event) {
        if (!this.enabled) {
            return
        }

        let method = 'clickedObjectIDs'
        const eventData = {
            eventName: 'Category Clicked',
            index: 'new_product_categories',
            objectIDs: event.detail.id ? [event.detail.id.toString()] : [],
            context: event.detail.context,
        }

        if (event.detail.queryId && event.detail.position) {
            method = 'clickedObjectIDsAfterSearch'
            eventData.queryID = event.detail.queryId
            eventData.positions = [event.detail.position]
        }

        event.preventDefault()

        window.aa(method, eventData)
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('searchInsights', searchInsights)
})
